import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared.module';
import { HeaderComponent } from './header.component';
import { MenubarModule } from 'primeng/menubar';
import { LeftNavModule } from '../left-nav/left-nav.module';
@NgModule({
    imports: [CommonModule,
        SharedModule,
        MenubarModule,
        LeftNavModule, HeaderComponent],
    exports: [HeaderComponent],
    providers: [],
})
export class HeaderModule {}
